
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/people/couriers-development",
      function () {
        return require("private-next-pages/csr/people/couriers-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/people/couriers-development"])
      });
    }
  